import { AuthCanActivateGuard } from '../auth/_guards/auth.can-activate.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuard } from '@app/auth/_guards/auth.can-deactivate-guard.service';
import { SftpdashboardDetailComponent } from './sftpdashboard-detail/sftpdashboard-detail.component';

let routes: Routes = [
	{
		path: '',
		redirectTo: 'sftpdashboard-detail',
		pathMatch: 'full'
	},
	{
		path: 'sftpdashboard-detail',
		component: SftpdashboardDetailComponent,
		canActivate: [ AuthCanActivateGuard ],
		canDeactivate: [ CanDeactivateGuard ],
		data: {
			label: "SFTP_DASHBOARD",
			expectedRoles: [8,1],
			breadcrumb: "SFTP_DASHBOARD",
		}
	}
];

// routes = extendSftpTrackingDashboardRoutingModuleRoutes(routes);

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class SftpTrackerDashboardRoutingModule
 {

}
